export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-list-bullet-14c671c91b9790f08e5f8226cd914563.svg";